module.exports = __webpack_public_path__ + "static/media/spice_open_graph.5cdebc27.jpg";